import Translate from "utils/translate";

const { t } = new Translate();

const dealName = ({ name, tenant = {}, tenantContact = {} }) =>
  name ||
  tenant.name ||
  (tenant.industry && t(`industries.${tenant.industry}`)) ||
  tenantContact.name ||
  t("undisclosed");

export default dealName;
